import { ObservableArray, View } from "binder"
import { PeriodicWarehouseCheckUpViewModel, WarehouseCheckUp } from "./periodicWarehouseCheckUp-viewModel"
import { ServerSideDataLoader } from "uicomponents";

export class PeriodicWarehouseCheckUpView extends View<PeriodicWarehouseCheckUpViewModel>{
    GetViewUniqueId(): string {
        return "V-9DDA256B-BBD0-4444-9CE3-87AC6AB03C06"
    }
    loadHtml(): string {
        let element = require('./periodicWarehouseCheckUp.html').default;
        let style = require('./periodicWarehouseCheckUp.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set warehouseCheckUps(v: ObservableArray<WarehouseCheckUp>) { this._warehouseCheckUps = v; } public get warehouseCheckUps(): ObservableArray<WarehouseCheckUp> { return this._warehouseCheckUps;} private _warehouseCheckUps: ObservableArray<WarehouseCheckUp>;
    
    print(){
        this.dataContext.printUncheckedWarehouseCheckUps();
    }
}
